import { NavLink } from "react-router-dom";
import { LayoutDashboard, UserCheck, Users, ClipboardList, CreditCard, Flag } from "lucide-react";

const TABS = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true, testid: "admin-tab-dashboard" },
  { to: "/admin/professionisti", icon: UserCheck, label: "Professionisti", testid: "admin-tab-pros" },
  { to: "/admin/utenti", icon: Users, label: "Utenti", testid: "admin-tab-users" },
  { to: "/admin/richieste", icon: ClipboardList, label: "Richieste", testid: "admin-tab-requests" },
  { to: "/admin/abbonamenti", icon: CreditCard, label: "Abbonamenti", testid: "admin-tab-subscriptions" },
  { to: "/admin/segnalazioni", icon: Flag, label: "Segnalazioni", testid: "admin-tab-reports" },
];

export function AdminNav() {
  return (
    <div className="px-4 sm:px-6 pt-4" data-testid="admin-nav">
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
        {TABS.map(({ to, icon: Icon, label, end, testid }) => (
          <NavLink key={to} to={to} end={end} data-testid={testid}
            className={({ isActive }) => `flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-colors active:scale-95 ${
              isActive ? "bg-slate-900 text-white" : "bg-white text-slate-600 border border-slate-200 hover:border-slate-300"
            }`}>
            <Icon className="w-4 h-4" /> {label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
